import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FilterModule } from '@gspwidget/widget-core';
import { TranslateModule } from '@ngx-translate/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { I18nInputModule } from '../config-editor2/i18n-input/i18n-input.module';
import { EditableTableModule } from '../editable-table/editable-table.module';
import { HelpModule } from '../help/help.module';
import { FeFilterModalComponent } from './fe-filter-modal.component';
import { XcHelp2Module } from '@gspwidget/util';

@NgModule({
  declarations: [
    FeFilterModalComponent
  ],
  // entryComponents: [
    // FeFilterModalComponent
  // ],
  imports: [
    CommonModule,
    FormsModule,
    NzRadioModule,
    FilterModule,
    TranslateModule,
    NzDatePickerModule,
    I18nInputModule,
    NzInputModule,
    NzSelectModule,
    NzInputNumberModule,
    NzButtonModule,
    EditableTableModule,
    HelpModule,
    XcHelp2Module,

  ],
  exports: [
    FeFilterModalComponent
  ]
})
export class FeFilterModalModule { }
